import {ShowAdminNews} from './show-admin-news';

export default ShowAdminNews;
